<template>
  <b-card>
    <!-- form -->
    <b-form v-if="currentUser && currentUser.is_ad != 1">
      <validation-observer ref="simpleRules">
        <b-row>
          <!-- old password -->
          <b-col md="6">
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group
                  label="Mật khẩu cũ"
                  label-for="account-old-password"
              >
                <b-input-group class="input-group-merge">
                  <b-form-input
                      id="account-old-password"
                      v-model="passwordValueOld"
                      :type="passwordFieldTypeOld"
                      name="old-password"
                      placeholder="Mật khẩu cũ"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                        :icon="passwordToggleIconOld"
                        class="cursor-pointer"
                        @click="togglePasswordOld"
                    />
                  </b-input-group-append>
                </b-input-group>
                <div class="error-txt">
                  <small v-if="errors.length > 0">Mật khẩu không được để trống</small>
                </div>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!--/ old password -->
        </b-row>
        <b-row>
          <!-- new password -->
          <b-col md="6">
            <validation-provider #default="{ errors }" rules="required|password" vid="confirm">
              <b-form-group
                  label="Mật khẩu mới"
                  label-for="account-new-password"
              >
                <b-input-group class="input-group-merge">
                  <b-form-input
                      id="account-new-password"
                      v-model="newPasswordValue"
                      :type="passwordFieldTypeNew"
                      name="new-password"
                      placeholder="Mật khẩu mới"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                        :icon="passwordToggleIconNew"
                        class="cursor-pointer"
                        @click="togglePasswordNew"
                    />
                  </b-input-group-append>
                </b-input-group>
                <div class="error-txt">
                  <small v-if="errors.length > 0">Mật khẩu phải chứa ít nhất 8 ký tự trong đó có ít nhất 1 ký tự hoa, 1
                    ký tự thường, 1 chữ số, 1 ký tự đặt biệt</small>
                </div>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!--/ new password -->

          <!-- retype password -->
          <b-col md="6">
            <validation-provider #default="{ errors }" rules="required|confirmed:confirm">
              <b-form-group
                  label="Nhập lại mật khẩu"
                  label-for="account-retype-new-password"
              >
                <b-input-group class="input-group-merge">
                  <b-form-input
                      id="account-retype-new-password"
                      v-model="RetypePassword"
                      :type="passwordFieldTypeRetype"
                      name="retype-password"
                      placeholder="Nhập lại"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                        :icon="passwordToggleIconRetype"
                        class="cursor-pointer"
                        @click="togglePasswordRetype"
                    />
                  </b-input-group-append>
                </b-input-group>
                <div class="error-txt">
                  <small v-if="errors.length > 0">Mật khẩu không hợp lệ</small>
                </div>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!--/ retype password -->

          <!-- buttons -->
          <b-col cols="12">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="mt-1 mr-1"
                variant="primary"
                @click="handChangePass"
            >
              Lưu thay đổi
            </b-button>
            <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mt-1"
                type="reset"
                variant="outline-secondary"
            >
              Reset
            </b-button>
          </b-col>
          <!--/ buttons -->
        </b-row>
      </validation-observer>
    </b-form>
    <div v-if="currentUser && currentUser.is_ad == 1" class="change-pass-group">
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          href="https://account.activedirectory.windowsazure.com/ChangePassword.aspx"
          target="blank" variant="primary"
      >Nhấn vào đây để đổi mật khẩu
      </b-button>
    </div>
  </b-card>
</template>

<script>
import {BButton, BCard, BCol, BForm, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BRow,} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {confirmed, required} from '@validations'
import useJwt from "@/auth/jwt/useJwt";

extend('password', (value) => {
  const specialChars = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*\(\)-_+=:;',?~<>{}]).{8,}$/
  return specialChars.test(value);
});

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      passwordValueOld: '',
      newPasswordValue: '',
      RetypePassword: '',
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      required,
      confirmed
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    currentUser() {
      return JSON.parse(localStorage.getItem("userData"));
    }
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    async handChangePass() {
      var validate = await this.$refs.simpleRules.validate().then(success => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Vui lòng kiểm tra dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
        })
        return;
      }
      useJwt.post('/changepass', {
        id: this.currentUser.username, "old_password": this.passwordValueOld, "password": this.newPasswordValue
      })
          .then(response => {
            this.$bvModal.hide('modal-pass')
            this.$toast({
              component: ToastificationContent,
              props: {title: 'Cập nhật thành công!', icon: 'CheckSquareIcon', variant: 'success'}
            })
          })
          .catch(error => {
            console.log(error.response);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Lỗi cập nhật người dùng [' + error.response.data.message + ']',
                icon: 'AlertTriangleIcon',
                variant: 'danger'
              }
            })
          })
    },
  },
}
</script>
<style scoped>
.error-txt small {
  color: red;
}

.change-pass-group {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
